import { c as _c } from "react/compiler-runtime";
import type { Hash } from 'viem';
import { Button } from '@repo/ui';
import { ArrowDiagonalUp } from '@repo/ui/icons';
import type { ChainId } from '../../../web3.types';
import { EtherscanLink } from '../../../components/EtherscanLink';
import { getBlockExplorerName } from '../../../utils/block-explorer.utils';
interface ActionFlowTransactionSummaryProps {
  hash: Hash;
  chainId: ChainId;
  status: 'success' | 'reverted';
}
export function ActionFlowTransactionSummary(t0) {
  const $ = _c(14);
  const {
    hash,
    chainId,
    status
  } = t0;
  const t1 = status === "success" ? "is complete" : "reverted";
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="text-muted-foreground mr-auto text-xs">Transaction {t1}</div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== chainId) {
    t3 = getBlockExplorerName(chainId);
    $[2] = chainId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ArrowDiagonalUp className="size-5" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <Button size="sm" variant="ghost" className="text-muted-foreground">View on {t3}{t4}</Button>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== chainId || $[8] !== hash || $[9] !== t5) {
    t6 = <EtherscanLink tx={hash} chainId={chainId}>{t5}</EtherscanLink>;
    $[7] = chainId;
    $[8] = hash;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <div className="flex items-center gap-2">{t2}{t6}</div>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}